import { ROW_ELIGIBLE_QUESTION_TYPES } from '../components/CrosstabBuilder/utilities/constants';

export const CROSSTAB_BUILDER_TAB = { id: 'crosstab-builder', label: 'Crosstab Builder' };
export const TURF_SIMULATOR_TAB = { id: 'turf-simulator', label: 'TURF Simulator' };

const RESPONSE_QUALITY_CUTOFF_DATE = '2026-09-21';

export const hasTurfQuestion = (questions = []) => questions.some(({ turf }) => turf === true);

export const canShowCrosstabBuilderTab = ({
  isCrosstabBuilderGateEnabled = false,
  publicToken,
  surveyQuestions,
} = {}) =>
  !publicToken &&
  isCrosstabBuilderGateEnabled &&
  Boolean(surveyQuestions?.some(({ type }) => ROW_ELIGIBLE_QUESTION_TYPES.includes(type)));

export const canShowResponseQualityTab = ({
  createdDatetime,
  isResponseQualityGateEnabled = false,
  publicToken,
} = {}) =>
  !publicToken &&
  isResponseQualityGateEnabled &&
  createdDatetime?.slice(0, 10) >= RESPONSE_QUALITY_CUTOFF_DATE;

export const canShowTurfSimulatorTab = ({
  isTurfSimulatorGateEnabled = false,
  publicToken,
  surveyQuestions,
} = {}) => !publicToken && isTurfSimulatorGateEnabled && hasTurfQuestion(surveyQuestions);
